import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function LegacyAskWittyRedirect() {
  const location = useLocation();
  return <Navigate replace to={{
    pathname: location.pathname.replace(/^\/ask-witty(?=\/|$)/, "/askwitty"),
    search: location.search,
    hash: location.hash,
  }} state={location.state} />;
}
